<template>
    <b-row no-gutters>
        <b-col cols="12" md="3" order="2" order-md="1" class="d-flex align-items-center justify-content-center" :class="stream && hasActiveTickets ? ['bg-dark', 'text-white'] : []">
            <draw-container v-if="stream && hasActiveTickets"
              class="pt-4 pb-4"
              :style="{ height: `${coverHeight}px` }"
              :game-id="gameId">
            </draw-container>
            <head-block v-else class="p-2 p-md-3 mt-0 mb-0 mt-md-5 mb-md-5" :game-id="gameId"></head-block>
        </b-col>
        <b-col cols="12" md="9" order="1" order-md="2" class="cover" ref="cover" :style="{ height: `${coverHeight}px` }">
            <player v-if="stream"
                :url="stream.url"
                :code="drawCode"
                :estimated-duration="estimatedDuration"
                :is-static-video="game.studio_static_video"
                :draw-start="nextDrawStart"
                @finish="finishStream">
            </player>
            <div class="tutorial" v-else>
              <b-button class="extra-rounded home-button" variant="outline-light" @click="goHome" v-if="homeLink">
                <div class="d-flex justify-content-center align-items-center">
                  <span class="home-icon"></span>
                </div>
              </b-button>
              <b-button class="extra-rounded tutorial-button" variant="outline-light" :to="{ name: 'tutorial' }"><fa-icon icon="info-circle"></fa-icon> <span>{{ 'how_to_play' | lang }}</span></b-button>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import HeadBlock from '@tv/components/partials/header/HeadBlock';
import Player from '@tv/components/partials/header/Player';
import DrawContainer from '@tv/components/partials/tickets/DrawContainer';
import { mapState, mapMutations } from 'vuex';

export default {
    props: ['gameId'],
    components: { HeadBlock, Player, DrawContainer },

    data() {
        return {
            coverHeight: 0,
            resizeCallback: undefined,
            homeLink: Config.home_url,
        };
    },

    computed: {
        ...mapState(['streams', 'channels_live_codes', 'channels']),

        game() {
            return Config.games[this.gameId];
        },

        drawCode() {
            return this.channels_live_codes[this.game.channel_id];
        },

        estimatedDuration() {
            return this.game.studio_max_duration / 2;
        },

        stream() {
            return this.streams.find(stream => stream.channelId == this.game.channel_id);
        },

        hasActiveTickets() {
            return this.$store.getters.activeTicketsOfDraw(this.game).length > 0;
        },

        nextDrawStart() {
            return this.channels[this.game.channel_id].draws.next.datetime;
        },
    },

    methods: {
        ...mapMutations(['removeStream']),

        finishStream() {
            console.log('Finish triggered');
            this.removeStream(this.game.channel_id);
        },

        updateHeight() {
            if(this.$refs.cover) {
                this.coverHeight = Math.floor(this.$refs.cover.clientWidth / (16 / 9));
            }
        },
        goHome() {
          if (window.parent) {
            window.open(this.homeLink, '_top');
          } else {
            window.location = this.homeLink;
          }
        },
    },

    created() {
        this.$nextTick(() => this.updateHeight());

        this.resizeCallback = window.addEventListener('resize', () => this.updateHeight());
    },

    destroyed() {
        window.removeEventListener('resize', this.resizeCallback);
    },
}
</script>
